var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqsIcon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7317 4.61572V33.6779H10.2617V4.61572",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69201 1.32227H26.3031C26.6426 1.32227 26.917 1.59671 26.917 1.93615V4.00171C26.917 4.34115 26.6426 4.6156 26.3031 4.6156H9.69201C9.35257 4.6156 9.07812 4.34115 9.07812 4.00171V1.93615C9.07812 1.59671 9.35257 1.32227 9.69201 1.32227Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2627 33.6778H1.24219V11.679H10.2627",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7344 11.679H34.7622V33.6778H25.7344",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4609 13.3473V11.3612H17.0065V9.81567H18.9926V11.3612H20.5309V13.3473H18.9926V14.8929H17.0065V13.3473H15.4609Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9964 17.4134C20.7841 17.4134 23.0591 15.1384 23.0591 12.3506C23.0591 9.56284 20.7841 7.28784 17.9964 7.28784C15.2086 7.28784 12.9336 9.56284 12.9336 12.3506C12.9336 15.1384 15.2086 17.4134 17.9964 17.4134Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1016 33.6779V21.1184H22.9021V33.6779",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9961 33.6779V21.1184",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0078 25.1919V26.0225V26.1741",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 25.1919V26.0225V26.1741",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91264 16.6189H3.59375V23.8628H7.91264V16.6189Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4048 16.6189H28.0859V23.8628H32.4048V16.6189Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsIcon7);
export default __webpack_public_path__ + "static/media/faqs-icon-7.2aac9754b68e12e2d9de0a1495f9060f.svg";
export { ForwardRef as ReactComponent };